/* One delegated listener also covers Shopify variant/section replacements. */
(() => {
  if (window.tendaMaterialZoomInstalled) return;
  window.tendaMaterialZoomInstalled = true;
  let dialog, trigger, inputId, scale = 1, previousOverflow;
  const setZoom = value => {
    scale = Math.max(1, Math.min(3, value));
    dialog.querySelector('img').style.width = `${scale * 100}%`;
    dialog.querySelector('[data-zoom-level]').textContent = `${Math.round(scale * 100)}%`;
    dialog.querySelector('[data-zoom-out]').disabled = scale === 1;
    dialog.querySelector('[data-zoom-in]').disabled = scale === 3;
  };
  const createDialog = () => {
    dialog = document.createElement('dialog');
    dialog.className = 'tenda-material-dialog';
    dialog.setAttribute('aria-labelledby', 'tenda-material-dialog-title');
    dialog.innerHTML = `
      <header><div><h2 id="tenda-material-dialog-title"></h2><p data-material-price></p></div>
        <button type="button" data-zoom-close aria-label="Kapat">×</button></header>
      <div class="tenda-material-dialog__viewport" tabindex="0" aria-label="Doku görseli; büyüttükten sonra kaydırabilirsiniz">
        <img alt="" width="1760" height="1435"><p data-image-error hidden>Görsel yüklenemedi. Lütfen tekrar deneyin.</p>
      </div>
      <footer><div class="tenda-material-dialog__tools" aria-label="Görsel yakınlaştırma">
        <button type="button" data-zoom-out aria-label="Uzaklaştır">−</button>
        <output data-zoom-level aria-live="polite">100%</output>
        <button type="button" data-zoom-in aria-label="Yakınlaştır">+</button>
        <button type="button" data-zoom-reset>Sıfırla</button>
      </div><button type="button" data-material-select>Bu dokuyu seç</button></footer>`;
    document.body.append(dialog);
    dialog.addEventListener('keydown', event => {
      if (event.key !== 'Tab') return;
      const controls = [...dialog.querySelectorAll('button:not(:disabled), [tabindex="0"]')];
      const first = controls[0], last = controls[controls.length - 1];
      if ((event.shiftKey && document.activeElement === first) || (!event.shiftKey && document.activeElement === last)) {
        event.preventDefault();
        (event.shiftKey ? last : first).focus();
      }
      event.stopPropagation();
    });
    dialog.querySelector('[data-zoom-close]').addEventListener('click', () => dialog.close());
    dialog.querySelector('[data-zoom-in]').addEventListener('click', () => setZoom(scale + .5));
    dialog.querySelector('[data-zoom-out]').addEventListener('click', () => setZoom(scale - .5));
    dialog.querySelector('[data-zoom-reset]').addEventListener('click', () => setZoom(1));
    dialog.querySelector('[data-material-select]').addEventListener('click', () => {
      const input = document.getElementById(inputId);
      dialog.close();
      if (input && !input.disabled && !input.classList.contains('disabled')) input.click();
    });
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
    });
    dialog.addEventListener('close', () => {
      document.documentElement.style.overflow = previousOverflow;
      if (trigger?.isConnected) trigger.focus();
      else document.getElementById(inputId)?.focus();
    });
    dialog.querySelector('img').addEventListener('error', () => {
      dialog.querySelector('[data-image-error]').hidden = false;
    });
  };
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-material-zoom]');
    if (!button) return;
    event.preventDefault();
    if (!dialog) createDialog();
    trigger = button;
    inputId = button.dataset.inputId;
    dialog.querySelector('h2').textContent = button.dataset.materialName;
    dialog.querySelector('[data-material-price]').textContent = button.dataset.materialPrice;
    const image = dialog.querySelector('img');
    image.alt = `${button.dataset.materialName} doku görseli`;
    dialog.querySelector('[data-image-error]').hidden = true;
    image.src = button.dataset.imageUrl;
    const input = document.getElementById(inputId);
    dialog.querySelector('[data-material-select]').disabled = !input || input.disabled || input.classList.contains('disabled');
    setZoom(1);
    const viewport = dialog.querySelector('.tenda-material-dialog__viewport');
    viewport.scrollTop = viewport.scrollLeft = 0;
    previousOverflow = document.documentElement.style.overflow;
    document.documentElement.style.overflow = 'hidden';
    dialog.showModal();
    dialog.querySelector('[data-zoom-close]').focus();
  });
})();
